import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { iotOrderForm } from '../../../../utils/constant';
import { Button } from './css';

const Continue = ({ orderData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, continueLabel },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;
  const { locale, categoryName, id, isQuoteReference } = orderData;
  const history = useHistory();

  const handleModifyQuote = () => {
    history.push({
      pathname: `/${locale}/${categoryName}/${iotOrderForm}`,
      search: `?orderId=${id}`
    });
    window.location.reload();
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>{continueLabel}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText="Are you sure you want to continue with this order"
        confirmCTAText={confirmButtonLabel}
        cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleModifyQuote()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

Continue.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default Continue;
